module.exports = __webpack_public_path__ + "img/image_6.cafd85b7.png";